import { buySubmissionFormEventDataSchema } from "@/core";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const buyFormDataSchema =
  buySubmissionFormEventDataSchema.shape.data.omit({
    miles: true,
    averageRate: true,
    totalPayout: true,
  });

export type BuyFormData = z.infer<typeof buyFormDataSchema>;

export function useBuyForm(defaultValues: Partial<BuyFormData> = {}) {
  const form = useForm<BuyFormData>({
    resolver: zodResolver(buyFormDataSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: defaultValues.firstName || "",
      lastName: defaultValues.lastName || "",
      frequentFlyerNumber: defaultValues.frequentFlyerNumber || "",
      accountEmail: defaultValues.accountEmail || "",
      receivedMilesBefore: defaultValues.receivedMilesBefore || "",
      notes: defaultValues.notes || "",
    },
  });

  return form;
}
